import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';
import PropertyCard from 'components/PropertyCard';
import { animationKeyframes } from 'lib/animations';
import { useDataLayer } from 'hooks/useDataLayer';
import { usePersonalisation } from 'hooks/usePersonalisation';
import { PropertyCardProps } from 'types/property';
import useSelectItemEvent from 'hooks/useSelectItemEvent';
import { useSelector } from 'react-redux';
import { getQueryLocation, getQueryRecommended } from 'store/router/routerSelectors';
import { getResults } from 'store/search/searchSelectors';
import { useRouter } from 'next/router';
import { PageType } from 'lib/analytics/enums';

const AnimationWrapper = styled(Box)`
  flex: 1 1 auto;
  animation: ${animationKeyframes.fadeInSlideUp10} ease 250ms;
  margin-bottom: ${themeGet('space.4')};
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`;

const FixedPropertyCard = (props: PropertyCardProps) => {
  const { id: propertyId } = props;
  const { emitInteractionEvent } = useDataLayer();
  const router = useRouter();
  const isRebooked = router.query.ss_action === 'rebook';
  const recommendedProperty = useSelector(getQueryRecommended);
  const { fireSelectItemEvent } = useSelectItemEvent();
  const location = useSelector(getQueryLocation);
  const searchResults = useSelector(getResults);
  const personalisation = usePersonalisation();
  const handlePropertyCardClick = useCallback(() => {
    const result = searchResults.find((r) => r.property.id === propertyId);
    if (result) {
      fireSelectItemEvent({
        listName: `Hotels in ${location}`,
        type: 'map',
        property: result.property,
        offer: result.offer,
        roomType: result.roomType,
        pageType: PageType.MAP,
        isRebooked: isRebooked,
        recommendedProperty: recommendedProperty,
      });
    }
    emitInteractionEvent({ type: 'Price Marker', value: 'Property Card Selected' });
    personalisation.trackMapClick(propertyId);
  }, [searchResults, emitInteractionEvent, personalisation, propertyId, fireSelectItemEvent, location, recommendedProperty, isRebooked]);

  return (
    <AnimationWrapper data-testid="fixed-property-card-wrapper">
      <PropertyCard inline onClick={handlePropertyCardClick} {...props} showCampaignMessage />
    </AnimationWrapper>
  );
};

export default FixedPropertyCard;
